export default "__VITE_ASSET__DnCn9LEN__"